import useSWR from 'swr';
import API from './api';
import {
    InstitutionLicenses,
    InstitutionUser,
    Lecture,
    LectureCategory,
    RecommendedCategory,
    Tracker,
} from './types.ts';
import useSWRImmutable from 'swr/immutable';

/**
 * Fetcher for SWR for routes returning data in body
 * @param url api route url
 * @returns {Promise}
 */
const fetcherNoData = (url: string) => API.get(url).then((res) => res.data);

export const useFetchRootCategories = () =>
    useSWRImmutable<LectureCategory[]>('/categories', fetcherNoData);

export const RECENTLY_PLAYED_LECTURES_KEY = '/lectures/recently-played';
export const useFetchRecentlyPlayedLectures = () =>
    useSWR<Lecture[]>(RECENTLY_PLAYED_LECTURES_KEY, fetcherNoData);

export const useFetchRecommendedLectures = () =>
    useSWRImmutable<RecommendedCategory[]>(
        '/categories/recommended',
        fetcherNoData
    );

export const useFetchSubCategories = (category: string) =>
    useSWRImmutable<LectureCategory[]>(
        `/categories/${category}/categories`,
        fetcherNoData
    );

export const useFetchSubCategory = (category: string) =>
    useSWRImmutable<LectureCategory>(`/categories/${category}`, fetcherNoData);

export const useFetchTracker = () => useSWR<Tracker>('/tracker', fetcherNoData);

export const useFetchInstitutionUsers = () =>
    useSWR<InstitutionUser[]>('/institution/users', fetcherNoData);

export const useFetchInstitutionLicenses = () =>
    useSWR<InstitutionLicenses>('/institution/licenses', fetcherNoData);

export const useFetchAutocompleteSchools = (query: string) =>
    useSWRImmutable(
        // Check if query is at least 2 characters long
        query.length < 2
            ? null
            : `/registration/autocomplete/schools?query=${query}`,
        fetcherNoData
    );

export const useFetchLicensePrices = () =>
    useSWRImmutable('/license-prices', fetcherNoData);
